import React from "react";
import { useParams } from "wouter";

import { CashLadder } from ".";
import { PmSelectPrompt } from "./PmSelectPrompt";
import { serializeDate } from "../../../../components/src/dateFormater";
import { DateForm } from "../../../../components/src/dateForm";
import { Alert } from "../../../../components/src/Alert";
import { useQueryState } from "../../../../components/src/use-query-state";

export const CashLadderView = (): React.ReactElement => {
    const { id }: any = useParams();
    const [endDate] = useQueryState("endDate", new Date().toISOString().slice(0, 10));
    const cashLadderEndDate = serializeDate(new Date(), "YYYY-MM-DD", 30);
    const today = new Date().toISOString().slice(0, 10);
    if (typeof id === "undefined" || id === "all") return <PmSelectPrompt message="Select a client" />;
    return (
        <div>
            <div className="flex mt-3 mb-4">
                <DateForm defaultDateString={endDate} dateName="endDate"></DateForm>
                {endDate !== today ? (
                    <Alert variant="danger" className="ml-2">
                        Historical or future date selected
                    </Alert>
                ) : null}
            </div>
            <CashLadder clientId={id} endDate={cashLadderEndDate} ordersTradeDate={endDate} />
        </div>
    );
};
